module.exports = __webpack_public_path__ + "static/media/corporate-services-img48.62b5c6da.jpg";